<template>
  <div id="app">
    <app-login v-if="!getAdmin"></app-login>
    <div v-if="getAdmin">
      <app-header></app-header>
      <section class="w-100 d-flex flex-row section-1">
        <app-navigation></app-navigation>
        <section class="d-flex flex-column justify-content-between section-2">
          <router-view></router-view>
          <app-footer></app-footer>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import Header from './components/shared/Header'
import Footer from './components/shared/Footer'
import Navigation from './components/shared/Navigation'
import Login from './components/Login'
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {
    AppHeader: Header,
    AppFooter: Footer,
    AppNavigation: Navigation,
    AppLogin: Login,
  },
  data () {
    return {
      login: false
    }
  },
  methods: {
    ...mapMutations([
        'setAdmin'
    ]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([
      'getAdmin'
    ])
  },
  beforeCreate() {},
  created() {
    this.login = (sessionStorage.getItem("token"))
      if(this.login) this.setAdmin(true)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss">
.cursor-pointer{
  cursor: pointer;
}
#app{
  height: 100% !important;
  background-image: url(./assets/img/bg-body.jpg);
  //background-color: var(--color-dark-gray, rgba(51, 51, 51, 1));
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  & > div{
    & > section.section-1{
      & > section.section-2{
        padding-left: 1rem;
        padding-right: 1rem;
        width: 100%;
        min-height: 100vh;
      }
    }
  }
}

/* Start Colors */

// color variables
:root {
  --color-dark-gray: rgba(51, 51, 51, 1);
  --color-light-dark-gray: rgba(51, 51, 51, .5);
  --color-golden-orange: rgba(204, 204, 0, 1);
  --color-light-golden-orange: rgba(204, 204, 0, .5);
  --color-white: rgba(255, 255, 255, 1);
  --color-light-white: rgba(255, 255, 255, .5);
  --color-black: rgba(0, 0, 0, 1);
  --color-light-black: rgba(0, 0, 0, .5);
}

// color classes
.color-dark-gray {color: var(--color-dark-gray, rgba(51, 51, 51, 1))}
.color-light-dark-gray {color: var(--color-light-dark-gray, rgba(51, 51, 51, .5))}
.color-golden-orange {color: var(--color-golden-orange, rgba(204, 204, 0, 1))}
.color-light-golden-orange {color: var(--color-light-golden-orange, rgba(204, 204, 0, .5))}
.color-white {color: var(--color-white, rgba(255, 255, 255, 1))};
.color-light-white {color: var(--color-light-white, rgba(255, 255, 255, .5))};
.color-black {color: var(--color-black, rgba(0, 0, 0, 1))};
.color-light-black {color: var(--color-light-black, rgba(0, 0, 0, .5))};

// background-color classes
.bg-color-dark-gray {background-color: var(--color-dark-gray, rgba(51, 51, 51, 1))}
.bg-color-light-dark-gray {background-color: var(--color-light-dark-gray, rgba(51, 51, 51, .5))}
.bg-color-golden-orange {background-color: var(--color-golden-orange, rgba(204, 204, 0, 1))}
.bg-color-light-golden-orange {background-color: var(--color-light-golden-orange, rgba(204, 204, 0, .5))}
.bg-color-white {background-color: var(--color-white, rgba(255, 255, 255, 1))};
.bg-color-light-white {background-color: var(--color-light-white, rgba(255, 255, 255, .5))};
.bg-color-black {background-color: var(--color-black, rgba(0, 0, 0, 1))};
.bg-color-light-black {background-color: var(--color-light-black, rgba(0, 0, 0, .5))};

/* End Colors */
</style>



// WEBPACK FOOTER //
// src/App.vue